angular.module('dashboard').config(['AppRoutesProvider', '$stateProvider',
    function (AppRoutesProvider, $stateProvider) {
        'use strict';

        var portalSettings = { toolbarItem: 'welcome' };

        var appRoutes = {
            'dashboard': {
                state: 'dashboard',
                route: '/dashboard',
                portalSettings: portalSettings
            }
        };

        AppRoutesProvider.setupAppRoutes(appRoutes);

        $stateProvider
            .state(appRoutes.dashboard.state, {
                url: appRoutes.dashboard.route,
                templateUrl: '/dashboard/views/dashboard.html',
                controller: 'DashboardCtrl',
                description: '/Dashboard',
                resolve: {
                    $title: function (gettextCatalog) { return gettextCatalog.getString('Welcome'); }
                }
            });
    }]);